
<!-- TEMPLATE -->
<template>
  <!-- PLUGINS REPORTERS-->

  <div class="card">
    <div class="card-header">
      <h5 class="card-category">Phishing reporter</h5>
      <v-btn v-on:click="reportPhishingDomain()" class="btn btn-icon" dark>
        <v-icon>mdi-email-send</v-icon>
      </v-btn>
    </div>
    <div class="card-body">
      <div></div>
    </div>

    <v-expansion-panels :readonly="readonly" multiple>
      <v-expansion-panel>
        <v-expansion-panel-header>Reporting to</v-expansion-panel-header>
        <v-expansion-panel-content>
          <ul>
            <li style="color: black" v-for="item in reports" :key="item.id">
              {{ item.target }}
            </li>
          </ul>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
  </div>
</template>

<!-- SCRIPT -->
<script>
import PhishingApi from "../app/phishing-api";
export default {
  name: "Reporters",
  data: function () {
    return {
      columns: [
        { text: "To", value: "target", sortable: true, align: "start" },
        { text: "Logo", value: "logo", sortable: true, align: "start" },
        { text: "Link", value: "link", sortable: true, align: "start" },
        {
          text: "Timestamp",
          value: "timestamp",
          sortable: true,
          align: "start",
        },
        {
          text: "Submitted",
          value: "submitted",
          sortable: true,
          align: "start",
        },
      ],
      reports: [],
      loading: false,
    };
  },
  created() {
    this.getReporterList();
  },
  filters: {
    toReadableDate(value) {
      return new Date(value * 1000).toLocaleString();
    },
  },
  methods: {
    getReporterList: function () {
      let id = this.$store.getters.detailsDomain;

      PhishingApi.getSubmissionList(id)
        .then((response) => {
          this.loading = false;
          this.reports = response;
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    reportPhishingDomain: function () {
      this.loading = true;
      let id = this.$store.getters.detailsDomain;

      PhishingApi.submitPhishingDomain(id)
        .then((response) => {
          setTimeout(() => {
            this.$store.dispatch("udpateDetailsDomain");
            this.getReporterList();
          }, 3000);
        })
        .catch(function (error) {
          console.log(error);
        });
    },
  },
  components: {},
};
</script>

<!-- Style -->
<style>
</style>



 


